import React, { useMemo } from "react";
import styles from "./index.module.css";

function Loader({ fullHeight = true, isHome = false }) {
  const height = useMemo(() => {
    if (isHome) {
      return "100vh"
    } else if (fullHeight) { return "80vh"; }
    else {
      return "100%"
    }
  }, [isHome, fullHeight])
  return (
    <div
      style={{
        width: "100%",
        height,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div className={styles.loader}></div>
    </div>
  );

}

export default Loader;
